<template>
    <rd-container size="large">
        <rd-header :title="$t('index.title', { totalCount : getPzzCentersTotalCount })">
            <dx-button :use-submit-behavior="false"
                       type="default"
                       :text="$t('index.captions.refresh')"
                       @click="refreshPzzCenters">
            </dx-button>
        </rd-header>
        <div class="row">
            <rd-column :size="$columns.TwelveOnLg">
                <!-- Grid -->
                <dx-data-grid :data-source="getPzzCentersList"
                              :remote-operations="true"
                              :allow-column-resizing="true"
                              :column-auto-width="false"
                              :control-column-resizing="false"
                              :repaint-changes-only="true"
                              :allow-column-reordering="true"
                              :row-alternation-enabled="true"
                              :hover-state-enabled="true"
                              class="main-datagrid"
                              ref="gridData">
                    <dx-filter-row :visible="true"
                                   apply-filter="auto"
                                   :show-operation-chooser="false" />
                    <dx-column data-field="Name"
                               :caption="$t('index.captions.center')"
                               data-type="string" />
                    <dx-column data-field="Symbol"
                               :caption="$t('index.captions.symbol')"
                               data-type="number" />
                    <dx-column data-field="IsActive"
                               :allow-filtering="false"
                               :allow-reordering="false"
                               :allow-resizing="false"
                               alignment="center"
                               :width="175"
                               :caption="$t('index.captions.visible')"
                               cell-template="showOnFilterCellTemplate" />
                    <dx-pager :allowed-page-sizes="pageSizes"
                              :show-page-size-selector="true" />
                    <div slot="showOnFilterCellTemplate" slot-scope="{ data }">
                        <i @click="function(){  toggleVisibiity(data.data.Id); }" :title="data.data.IsActive ? $t('index.captions.visibilityOFF'): $t('index.captions.visibilityOFF')" class="main-datagrid-btn" :class="data.data.IsActive ? 'fas fa-eye': 'fas fa-eye-slash'"></i>
                    </div>
                    <dx-paging :page-size="30" />
                </dx-data-grid>

            </rd-column>
        </div>
        <DxLoadPanel 
                     :visible.sync="getLoadingVisible"
                     :show-indicator="true"
                     :show-pane="true"
                     :shading="true"
                     shading-color="rgba(0,0,0,0.4)" />
    </rd-container>
</template>
<script>
    // @ is an alias to /src
    import {
        DxDataGrid,
        DxColumn,
        DxFilterRow,
        DxPager,
        DxPaging
    } from 'devextreme-vue/data-grid';
    import DxButton from 'devextreme-vue/button';
    import { DxLoadPanel } from 'devextreme-vue/load-panel';

    import { mapFields } from 'vuex-map-fields';
    import { mapGetters, mapActions } from 'vuex';
    import commonMessages from '../../locales';
    import localMessages from '../locales';


    const name = "administrationStores/dictionariesStores/pzzCentersStores/indexStore";


    export default {
        name: 'appPzzCentersList',
        data() {
            return {
                pageSizes: [30, 50, 100],
                loadingVisible: true,
            }
        },
        computed: {
            ...mapGetters(name, ['getPzzCentersList', 'getPzzCentersTotalCount','getLoadingVisible']),
            ...mapFields(name, [
            ]),
        },
        methods: {
            ...mapActions(name, ['setPzzCentersList', 'setLoaded', 'setPzzCentersTotalCount', 'toggleVisibiity', 'setToken', 'refreshPzzCenters']),
            
        },
        mounted() {
            var gridInstance = this.$refs.gridData.instance;
            var setPzzCentersTotalCount = this.setPzzCentersTotalCount;
            this.setLoaded(() => {
                this.totalCount = setPzzCentersTotalCount(gridInstance.totalCount());
            });
            this.setPzzCentersList();
            this.setToken();
        },
        components: {
            DxDataGrid,
            DxColumn,
            DxFilterRow,
            DxPager,
            DxPaging,
            DxButton,
            DxLoadPanel
        },
        i18n: {
            messages: localMessages.messages,
            sharedMessages: commonMessages.messages
        }
    }
</script>